import { render, staticRenderFns } from "./ErrorContainer.vue?vue&type=template&id=55c78b9e&scoped=true"
import script from "./ErrorContainer.vue?vue&type=script&lang=js"
export * from "./ErrorContainer.vue?vue&type=script&lang=js"
import style0 from "./ErrorContainer.vue?vue&type=style&index=0&id=55c78b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c78b9e",
  null
  
)

export default component.exports